import React from "react";

const CheckIcon = () => (
  <svg
    className="w-5 h-5 text-[#865AF2] mr-3 shrink-0 mt-0.5"
    fill="currentColor"
    viewBox="0 0 20 20"
  >
    <path
      fillRule="evenodd"
      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
      clipRule="evenodd"
    />
  </svg>
);

export function ProBenefitInfo() {
  return (
    <div className="flex flex-col justify-center items-center lg:w-[60%] w-[90%] mb-4">
      <div className="flex flex-col mb-8 items-center text-center">
        <h2 className="text-[28px] font-extrabold bg-clip-text text-transparent bg-gradient-to-r from-[#FF7A59] to-[#FF4D4D] tracking-wide mb-2 drop-shadow-sm">
          Exclusive Discount Only Today
        </h2>
        <div className="inline-flex items-center bg-[#FF4D4D]/10 px-4 py-1.5 rounded-full border border-[#FF4D4D]/20">
          <span className="text-white/80 text-[15px] font-medium mr-1">
            up to
          </span>
          <span className="text-[#FF4D4D] text-[18px] font-bold mx-1">80%</span>
          <span className="text-white/80 text-[15px] font-medium">
            off for first subscription
          </span>
        </div>
      </div>

      <div className="w-full bg-[#1F2128]/50 backdrop-blur-sm border border-white/5 rounded-2xl p-6 lg:p-8 shadow-2xl">
        <div className="flex flex-row justify-center mb-6">
          <h3 className="text-[22px] font-bold text-white tracking-wide">
            Pro Benefit
          </h3>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-y-4 gap-x-8">
          <div className="flex items-start">
            <CheckIcon />
            <span className="text-white/90 text-[16px] font-medium">
              6000 credits per month
            </span>
          </div>
          <div className="flex items-start">
            <CheckIcon />
            <span className="text-white/90 text-[16px] font-medium">
              Unlock multitask
            </span>
          </div>
          <div className="flex items-start">
            <CheckIcon />
            <span className="text-white/90 text-[16px] font-medium">
              Priority queue
            </span>
          </div>
          <div className="flex items-start">
            <CheckIcon />
            <span className="text-white/90 text-[16px] font-medium">
              Face swap image generation
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
